import PropTypes from "prop-types";
import { Typography, Box, Snackbar, Alert, Dialog } from "@mui/material";
import styles from "./add.module.css";
import { ChevronLeft, Check } from "react-feather";
import { Link } from "react-router-dom";
import { useState } from "react";
import Step1 from "./components/Step1";
import Loader from "../../../admin/components/Loader";
import { useEffect } from "react";
import axios from "axios";
import { authData, withCustomerAuth } from "../../../admin/components/GetAuth";
import Step2 from "./components/Step2";
import Step3 from "./components/Step3";
import Step4 from "./components/Step4";
import { useWebsite } from "../../../context/WebsiteContext";
import { useSiteBranding } from "../../../hooks/useSiteBranding";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import DirectionsBoatIcon from "@mui/icons-material/DirectionsBoat";

const STEPS = ["Parcel Details", "Pickup Address", "Recipient Address", "Order Summary"];

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (<div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
    {value === index && (<Box className={styles.TabPanelBody}>
      <Typography component="div">{children}</Typography>
    </Box>)}
  </div>);
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

/* Postmark-style step indicator, replaces MUI Tabs so the flow
   reads like stamps on a consignment note rather than a generic tab bar. */
function ManifestStepper({ value }) {
  return (
    <div className={styles.StepperWrap}>
      {STEPS.map((label, index) => {
        const isDone = index < value;
        const isActive = index === value;
        return (
          <div className={styles.StepItem} key={label}>
            <div className={styles.StepBadgeCol}>
              <div
                className={`${styles.StepBadge} ${isActive ? styles.StepBadgeActive : ""} ${isDone ? styles.StepBadgeDone : ""}`}
                aria-current={isActive ? "step" : undefined}
              >
                {isDone ? <Check size={16} /> : String(index + 1).padStart(2, "0")}
              </div>
              <span className={`${styles.StepLabel} ${isActive ? styles.StepLabelActive : ""}`}>{label}</span>
            </div>
            {index < STEPS.length - 1 && (
              <div className={`${styles.StepConnector} ${isDone ? styles.StepConnectorDone : ""}`} />
            )}
          </div>
        );
      })}
    </div>
  );
}

function AddBooking({ history, match }) {
  const auth = authData();
  const [tabValue, setTabValue] = useState(0);
  const [bookingData, setBookingData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectPCountry, setSelectPCountry] = useState('GB');
  const [selectDCountry, setSelectDCountry] = useState('GH');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarType, setSnackbarType] = useState("success");
  const [freightGateOpen, setFreightGateOpen] = useState(true);
  const [freightType, setFreightType] = useState("");
  // Company collection/delivery charge settings; undefined while loading, null when none
  const [charges, setCharges] = useState(undefined);
  // "Other With Dimension" pricing; null falls back to the default formula
  const [dimensionPricing, setDimensionPricing] = useState(null);

  const { websiteData } = useWebsite();
  useSiteBranding("Add booking", websiteData);

  useEffect(() => {
    axios.get(process.env.REACT_APP_API_URL + "v1/customer/booking-charges", {
      headers: { Authorization: `Bearer ${auth?.api_token}` }
    }).then((response) => {
      setCharges(response.data.status === "SUCCESS" ? (response.data.data?.charges || null) : null);
      setDimensionPricing(response.data.status === "SUCCESS" ? (response.data.data?.dimension_pricing || null) : null);
    }).catch(() => setCharges(null));
  }, [auth?.api_token]);

  useEffect(() => {
    if (auth?.company?.pickup_country) {
      setSelectPCountry(auth?.company?.pickup_country);
    }
    if (auth?.company?.delivery_country) {
      setSelectDCountry(auth?.company?.delivery_country);
    }
  }, [auth?.company?.pickup_country, auth?.company?.delivery_country]);

  const saveStep1Data = (data) => {
    let bookingDataTemp = bookingData;
    bookingDataTemp = { ...bookingDataTemp, ...data };

    setBookingData(bookingDataTemp);
    setTabValue((prevValue) => prevValue + 1);
  };

  const saveStep2Data = (pickUpData) => {
    let bookingDataTemp = bookingData;
    bookingDataTemp = { ...bookingDataTemp, pickUpData: pickUpData };

    setBookingData(bookingDataTemp);
    setTabValue((prevValue) => prevValue + 1);
  };

  const saveStep3Data = (recipientData) => {
    let bookingDataTemp = bookingData;
    bookingDataTemp = { ...bookingDataTemp, recipientData: recipientData };

    setBookingData(bookingDataTemp);
    setTabValue((prevValue) => prevValue + 1);
  };

  const backToTab = () => {
    document.documentElement.scrollTo({ top: 0, left: 0, behavior: "instant" });
    setTabValue((prevValue) => prevValue - 1);
  }

  const selectFreightType = (type) => {
    setFreightType(type);
    setBookingData((prev) => ({ ...prev, freight_type: type }));
    setFreightGateOpen(false);
  };

  return (<>
    <Loader open={loading} setOpen={setLoading.bind(this)} />

    <div className={`${styles.MainDivCustomer}`}>
      <div className={`${styles.Container}`}>
        <Link to={"/customer/my-bookings"} className={`${styles.BackLink}`}>
          <ChevronLeft /> Back to all booking
        </Link>
        <div className={`${styles.MainCard}`}>

          <div className={styles.RouteHeader}>
            <div>
              <p className={styles.RouteMeta}>New consignment</p>
              <div className={styles.RoutePath}>
                <div className={styles.RouteCode}>
                  {selectPCountry}
                  <span>Pickup</span>
                </div>
                <div className={styles.RouteLine} />
                <div className={styles.RouteCode}>
                  {selectDCountry}
                  <span>Delivery</span>
                </div>
              </div>
            </div>
          </div>

          <Box sx={{ width: "100%" }}>
            <ManifestStepper value={tabValue} />

            <TabPanel value={tabValue} index={0}>
              <Step1 charges={charges} dimensionPricing={dimensionPricing}saveStep1Data={saveStep1Data.bind(this)} bookingData={bookingData} freightType={freightType} setFreightGateOpen={setFreightGateOpen.bind(this)} />
            </TabPanel>
            <TabPanel value={tabValue} index={1}>
              <Step2 charges={charges} saveStep2Data={saveStep2Data.bind(this)} backToTab={backToTab.bind(this)} bookingData={bookingData} selectCountry={selectPCountry} />
            </TabPanel>
            <TabPanel value={tabValue} index={2}>
              <Step3 charges={charges} saveStep3Data={saveStep3Data.bind(this)} backToTab={backToTab.bind(this)} bookingData={bookingData} selectCountry={selectDCountry} />
            </TabPanel>
            <TabPanel value={tabValue} index={3}>
              <Step4 booking_id={null} bookingData={bookingData} charges={charges} backToTab={backToTab.bind(this)} setLoading={setLoading.bind(this)} setSnackbarMessage={setSnackbarMessage.bind(this)} setSnackbarType={setSnackbarType.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} />
            </TabPanel>
          </Box>
        </div>
      </div>
    </div>

    <Dialog
      open={freightGateOpen}
      disableEscapeKeyDown
      fullWidth
      PaperProps={{ sx: { borderRadius: "20px", overflow: "hidden", maxWidth: "440px", width: "100%" } }}
    >
      <div className={styles.FreightDialogHeader}>
        <p className={styles.FreightDialogTitle}>How should this ship?</p>
        <p className={styles.FreightDialogSub}>Choose a freight option to continue your booking</p>
      </div>
      <div className={styles.FreightOptionsRow}>
        <button
          type="button"
          className={`${styles.FreightOptionCard} ${freightType === 'Air Freight' ? styles.FreightOptionCardActive : ''}`}
          onClick={() => selectFreightType('Air Freight')}
        >
          <FlightTakeoffIcon />
          <span>Air Freight</span>
          <small>Faster delivery, priced by weight</small>
        </button>
        <button
          type="button"
          className={`${styles.FreightOptionCard} ${freightType === 'Sea Freight' ? styles.FreightOptionCardActive : ''}`}
          onClick={() => selectFreightType('Sea Freight')}
        >
          <DirectionsBoatIcon />
          <span>Sea Freight</span>
          <small>Economical, priced by volume</small>
        </button>
      </div>
    </Dialog>

    <Snackbar
      open={snackbarOpen}
      autoHideDuration={6000}
      onClose={(e) => setSnackbarOpen(false)}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        onClose={(e) => setSnackbarOpen(false)}
        severity={snackbarType}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {snackbarMessage}
      </Alert>
    </Snackbar>
  </>);
}

export default withCustomerAuth(AddBooking);